// ABOUTME: TypeScript interfaces for email campaign creation and management
// ABOUTME: Defines request/response types for campaign API interactions

export enum CampaignExitCondition {
  None = 0,
  SubscriptionActive = 1,
  UserDeleted = 2,
  FamilyArchived = 3,
  TrialEnded = 4,
  AllStepsCompleted = 5
}

export enum EmailTemplateKey {
  Welcome = 1,
  PasswordReset = 2,
  EmailVerification = 3,
  EmailChangeConfirmation = 4,
  AccountLocked = 5,
  SecurityNotification = 6,
  Invitation = 10,
  FreeAccessGranted = 20,
  FreeAccessRevoked = 21,
  PaymentFailed = 22,
  PaymentRecovered = 23,
  SubscriptionCancelled = 24,
  SubscriptionRefunded = 25,
  GracePeriodEnding = 26,
  TrialDay7Warning = 30,
  TrialDay12Warning = 31,
  TermsOfServiceUpdate = 40,
  PrivacyPolicyUpdate = 41,
  AdminPaymentFailureAlert = 50,
  AdminRefundAlert = 51,
  SupportContactResponse = 60,
  TestEmail = 61,
  GeneralNotification = 70,
  DailySummary = 71,
  WeeklySummary = 72,
  BehaviorRecord = 73,
  GoalAchievement = 74
}

export interface CreateCampaignStepRequest {
  dayOffset: number;
  sendTime: string; // "HH:mm:ss" format
  templateId?: number | null;
  kbArticleId?: number | null;
}

export interface CreateEmailCampaignRequest {
  displayName: string;
  description?: string;
  exitConditionType: CampaignExitCondition;
  isActive: boolean;
  steps: CreateCampaignStepRequest[];
}

export interface AllowedTemplate {
  key: string;
  name: string;
  category: string;
  value: number;
}

export interface AllowedTemplatesResponse {
  templates: AllowedTemplate[];
}

export interface CheckNameResponse {
  available: boolean;
  generatedSlug: string;
  suggestedName?: string;
}

export interface CampaignStepResponse {
  id: number;
  stepOrder: number;
  dayOffset: number;
  sendTime: string;
  templateId?: number | null;
  kbArticleId?: number | null;
  kbArticleTitle?: string | null;
}

export interface EmailCampaignResponse {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  exitConditionType: CampaignExitCondition;
  isActive: boolean;
  steps: CampaignStepResponse[];
  activeEnrollmentsCount: number;
  completedEnrollmentsCount: number;
  totalEmailsSentCount: number;
}

export interface KBArticleDropdown {
  id: number;
  title: string;
  categoryName?: string | null;
}

export interface AvailableKBArticlesResponse {
  articles: KBArticleDropdown[];
}

export interface CampaignEnrollment {
  id: number;
  familyId: number;
  familyName: string;
  enrolledAt: string;
  status: string;
  currentStepNumber: number;
  totalSteps: number;
  emailsSent: number;
  totalScheduledEmails: number;
  triggerReason?: string | null;
}

export interface CampaignEnrollmentsResponse {
  data: CampaignEnrollment[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface DeleteEnrollmentResponse {
  message: string;
  cancelledEmailsCount: number;
}
